export enum MODAL_NAME {
  CERTSY = 'certsy',
  DETAILS_VIEW = 'details',
  BULK_ACTIONS_EMAIL = 'bulk_actions_email',
  BULK_ACTIONS_UPDATE_STATUS = 'bulk_actions_update_status',
  JOB_ACTIONS = 'job_actions',
  EXPIRE_CONFIRMATION = 'expire_confirmation',
  TEAM_MEMBER_ACCESS = 'team_member_access',
}

export enum OVERLAY_MODAL {
  USER_PREFERENCES = 'user-preferences',
}
